import { Row, Col, Container, Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import DcFooter from "../components/DcFooter";
import animationData from "../resources/run-man-run";
import { Link } from "react-router-dom";
import { root_url } from "../setting";

const NoticeAndGallery = ({ history }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    renderSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const [noticeList, setnoticeList] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${root_url}/api/notice`);
        console.log(data);
        const { posts } = data;
        let new_data = [];
        for (let i in posts) {
          const date = new Date(posts[i].createTime);
          // console.log(date);
          new_data.push({
            title: posts[i].title,
            date,
            postNo: posts[i].postNo,
          });
        }
        new_data = new_data.slice(0, 10);
        console.log(new_data);
        setnoticeList(new_data);
        //console.log(modalData);
      } catch (e) {
        console.log(e);
      }
    };
    fetchData();
  }, []);
  //console.log(data);
  const dateString = (date) => {
    return (
      <p>
        {date.getFullYear()}.{date.getMonth() + 1}.{date.getDate()}
      </p>
    );
  };
  return (
    <div>
      <Container
        className="h-50"
        style={{ height: "50vh", marginBottom: "40vh" }}
      >
        {/* <Lottie options={defaultOptions} height="200px" /> */}
        <Row>
          <Col
            md={{ span: 10, offset: 1 }}
            lg={{ span: 6, offset: 0 }}
            className="mb-3 mb-lg-0"
          >
            <h3>
              <Link to="/dashboard/notice?pageNo=1" style={{ color: "black" }}>
                공지사항 <i className="fas fa-chevron-right"></i>
              </Link>
            </h3>
            <Table size="sm" hover striped>
              <tbody>
                {noticeList.map((element, index) => {
                  return (
                    <tr
                      key={index}
                      onClick={() => {
                        history.push(`/dashboard/notice/${element.postNo}`);
                      }}
                      className="cursor-pointer"
                    >
                      <td style={{ width: "7%" }}>{index + 1}</td>
                      <td className="text-truncate">{element.title}</td>
                      <td
                        style={{ width: "20%", color: "black" }}
                        className="text-truncate"
                      >
                        {dateString(element.date)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
          
        </Row>
      </Container>
      <DcFooter />
    </div>
  );
};
export default NoticeAndGallery;
